import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface Income {
  dbId?: string;
  type: string;
  amount: string;
  frequency: string;
  propertyType?: string;
  noOfTitleHolders?: string;
  propertyExpense?: string;
  propertyAddress?: string;
}

interface IncomeData {
  income?: Income[];
}

interface StepState {
  currentStep: number;
  stepsData: IncomeData;
}
const initialState: StepState = {
  currentStep: 1,
  stepsData: {},
};

export const incomeDetails = createSlice({
  name: "incomeDetails",
  initialState,
  reducers: {
    nextStep: (state) => {
      if (state.currentStep < 3) state.currentStep += 1;
    },
    prevStep: (state) => {
      if (state.currentStep > 1) state.currentStep -= 1;
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    addStepsData: (state, action: PayloadAction<IncomeData>) => {
      state.stepsData = { ...state.stepsData, ...action.payload };
    },
    resetStepsData: (state) => {
      state.stepsData = {};
      state.currentStep = 1;
    },
  },
});

export const { nextStep, prevStep, setStep, addStepsData, resetStepsData } =
  incomeDetails.actions;

export default incomeDetails.reducer;
